export const researchIdentity = "Understanding, Securing and Engineering Trustworthy AI";

export const researchThemes = [
  {
    id: "interpretable-reliable-ml",
    title: "Interpretable and Reliable ML",
    summary: "Understanding how models work, explaining their decisions, and knowing when to trust them.",
    description: "We study the representations and mechanisms behind model behaviour, connecting explanations to evidence about reliability. Our goal is to make model decisions easier to inspect and failures easier to understand.",
    topics: ["Mechanistic interpretability and feature discovery", "Attribution and explanation methods", "Reliability, uncertainty and robustness evaluation"],
    question: "What drives a model's decisions, and when can we rely on them?"
  },
  {
    id: "trustworthy-agentic-systems",
    title: "Trustworthy Agentic and Autonomous Systems",
    summary: "Building agents that can reason, use tools, and act reliably under human oversight.",
    description: "We investigate how to engineer and evaluate AI systems that take actions across multiple steps. AI for Software Engineering is a central focus, from assisting developers to checking whether generated code and agent behaviour meet their intended requirements.",
    topics: ["AI for Software Engineering", "Agent reasoning, tool use and autonomous workflows", "Security, evaluation and human oversight"],
    question: "How can we build agents whose actions remain useful, secure and accountable?"
  },
  {
    id: "intelligent-decision-making",
    title: "Intelligent Decision-making and AI Applications",
    summary: "Turning advances in AI into useful decisions and applications that serve people.",
    description: "We develop methods for decision support and study how they work under real-world constraints. With AI for Social Good as a guiding direction, we consider who benefits from a system, how it is evaluated, and what responsible use requires.",
    topics: ["AI for Social Good", "Forecasting, recommendation and decision support", "Applications in finance, healthcare and public-interest settings"],
    question: "How can AI support better decisions and deliver meaningful benefits in practice?"
  }
];

// Add confirmed names and funding details here; do not infer endorsements from co-authorship.
export const acknowledgements = [
  {
    id: "contributors",
    title: "People and website contributors",
    description: "Thank you to the team members who develop our research and help share it, and to the contributors who design, build and maintain this website.",
    entries: []
  },
  {
    id: "collaborators",
    title: "Collaborators",
    description: "We thank our collaborators for the ideas, feedback and shared effort that shape our work across disciplines and institutions.",
    entries: []
  },
  {
    id: "funders",
    title: "Funders and research support",
    description: "We gratefully acknowledge the funding and institutional support that make this research possible.",
    entries: []
  }
];
